import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  FormGroupDirective,
  NgForm,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorStateMatcher } from '@angular/material/core';

import { UserService } from 'src/app/_services/user.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: UntypedFormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: 'app-email-confirm-dialog',
  templateUrl: './email-confirm.component.html',
  styleUrls: ['./email-confirm.component.css']
})
export class EmailConfirmDialogComponent implements OnInit {
  modalTitle: string;
  frmEmail = new UntypedFormControl('', [Validators.required, Validators.email]);

  matcher = new MyErrorStateMatcher();

  constructor(
    public dialogRef: MatDialogRef<EmailConfirmDialogComponent>,
    public snackBar: MatSnackBar,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.modalTitle = data.title;
  }

  ngOnInit() {}

  onSubmitForm() {
    const updatedUser = {
      email: this.frmEmail.value
    };

    this.userService.updateUser(updatedUser).subscribe(
      data => {
        this.snackBar.open(
          'Your email address has been updated. You will now be redirected',
          'Dismiss',
          {
            duration: 7000
          }
        );
        this.dialogRef.close();
      },
      error => {
        this.snackBar.open(error.errorMessage, 'Dismiss', {
          duration: 7000
        });
      }
    );
  }
}
